module.exports = __webpack_public_path__ + "static/media/welcome.d13ae698.jpg";